var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "BModal",
    {
      ref: "service-schedule-delete-shift-modal",
      attrs: {
        id: "service-schedule-delete-shift-modal",
        "hide-header": true,
        "no-close-on-backdrop": true,
        "no-fade": true,
        centered: true,
        size: "sm",
      },
      nativeOn: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.hideModal()
        },
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "close deleteShift__closeBtn",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.hideModal()
            },
          },
        },
        [_vm._v("\n\t\t×\n\t")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "deleteShift__header" }, [
        _c("div", { staticClass: "deleteShift__headerText" }, [
          _vm._v(
            "\n\t\t\tAre you sure you want to delete the following shift?\n\t\t"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "deleteShift__body" }, [
        _c("div", { staticClass: "deleteShift__bodyHeader" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.name) + "\n\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "deleteShift__bodySubheader" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.day) + "\n\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "deleteShift__bodySubheader" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.shiftTime) + "\n\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "deleteShift__bodySubheader" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.duration) + "\n\t\t"),
        ]),
      ]),
      _vm._v(" "),
      _c("template", { slot: "modal-footer" }, [
        _c(
          "div",
          { staticClass: "deleteShift__footer tw-w-full" },
          [
            _c(
              "BaseButton",
              {
                directives: [
                  {
                    name: "data-cy",
                    rawName: "v-data-cy",
                    value: "delete-shift-yes-btn",
                    expression: "'delete-shift-yes-btn'",
                  },
                ],
                staticClass: "deleteShift__btn deleteShift__btn--marginRight",
                attrs: { type: "CANCEL" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.deleteShift()
                  },
                },
              },
              [
                _c("template", { slot: "text" }, [
                  _vm._v("\n\t\t\t\t\tYes\n\t\t\t\t"),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "BaseButton",
              {
                staticClass: "deleteShift__btn",
                attrs: { type: "CANCEL" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.hideModal()
                  },
                },
              },
              [
                _c("template", { slot: "text" }, [
                  _vm._v("\n\t\t\t\t\tClose\n\t\t\t\t"),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }